const win = window
if (window.location.href.includes('localhost')) {
  win['lang'] = 'en'
  //win['lang'] = 'ar'
  document.documentElement.lang = win['lang']
}
